import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/hr/contracts/$contractId',
}).lazy(() => import('./$contractId.index.lazy').then((d) => d.Route))
